import React, { useState } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { compose } from 'recompose';

import Table from '../../../components/Table.DEPRECATED';
import { FILTERED_VENUE_RENTERS } from 'Queries/Admin/FilteredVenueRenters';
import withTableActions from '../../../enhancers/withTableActions';
import { formatPhoneNumber } from 'Helpers/formatPhoneNumber';
import IndeterminateLoading from '../../../components/Loading/IndeterminateLoading';

export const UsersTable = props => {
  const {
    userRoles,
    onEditClick,
    updateFilterTextField,
    updateSelect,
    getVariables,
    onSubmitFilter,
    onClearFilters,
    onRequestSort,
    onClearSingleFilter,
    handleTableChangePage,
    handleTableChangeRowsPerPage
  } = props;

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [role, setRole] = useState('');
  const [sortName, setSortName] = useState('firstName');
  const [sortOrder, setSortOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState(['firstName', 'ASC']);
  const [filterBy, setFilterBy] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [rowsPerPage, setRowsPerPage] = useState(10);
  // eslint-disable-next-line no-unused-vars
  const [page, setPage] = useState(0);

  const availableFilters = ['firstName', 'lastName', 'role'];

  const variables =
    getVariables &&
    getVariables({
      orderBy,
      filterBy,
      rowsPerPage,
      page
    });

  const { data, loading, error } = useQuery(FILTERED_VENUE_RENTERS, {
    variables: { ...variables },
    fetchPolicy: 'network-only'
  });

  const rows = [
    {
      id: 'editable',
      numeric: false,
      disablePadding: false,
      label: ''
    },
    {
      id: 'firstName',
      numeric: false,
      disablePadding: false,
      label: 'FIRST NAME',
      sortable: true
    },
    {
      id: 'lastName',
      numeric: false,
      disablePadding: false,
      label: 'LAST NAME',
      sortable: true
    },
    {
      id: 'email',
      numeric: false,
      disablePadding: false,
      label: 'EMAIL ADDRESS'
    },
    {
      id: 'phone',
      numeric: false,
      disablePadding: false,
      label: 'PHONE NUMBER'
    },
    {
      id: 'role',
      numeric: false,
      disablePadding: false,
      label: 'USER TYPE'
    }
  ];

  const renterTableData = venue => {
    const { users } = venue;
    return users.map(user => {
      return {
        id: `${user.id}`,
        role: user.role,
        firstName: `${user.firstName}`,
        lastName: `${user.lastName}`,
        email: `${user.email}`,
        phone: formatPhoneNumber(user.phone)
      };
    });
  };

  const filters = [
    {
      key: 'firstName',
      label: 'FIRST NAME',
      type: 'text',
      value: firstName,
      cb: updateFilterTextField && updateFilterTextField(setFirstName)
    },
    {
      key: 'lastName',
      label: 'LAST NAME',
      type: 'text',
      value: lastName,
      cb: updateFilterTextField && updateFilterTextField(setLastName)
    },
    {
      key: 'role',
      label: 'USER TYPE',
      type: 'select',
      value: role,
      options: userRoles ? Object.values(userRoles)[0] : null,
      cb: updateSelect && updateSelect(setRole),
      selectedOption: role
    }
  ];

  if (loading) return <IndeterminateLoading />;
  if (error) {
    // eslint-disable-next-line
    console.error(error);
    return 'uh oh...';
  }

  return (
    <Table
      filters={filters}
      rows={rows}
      data={renterTableData(data.venue)}
      onSubmit={onSubmitFilter(
        availableFilters,
        {
          firstName,
          lastName,
          role
        },
        setFilterBy,
        setPage
      )}
      onClearFilters={onClearFilters(
        availableFilters,
        {
          firstName: [firstName, setFirstName],
          lastName: [lastName, setLastName],
          role: [role, setRole]
        },
        setFilterBy
      )}
      onEditClick={onEditClick}
      orderBy={sortName}
      order={sortOrder}
      onRequestSort={onRequestSort({ sortName, sortOrder }, { setSortName, setSortOrder, setOrderBy })}
      onClearSingleFilter={onClearSingleFilter(filterBy, setFilterBy)}
      count={data.allVenueUsers.users.length}
      allTableRows={data.allVenueUsers.users}
      page={page}
      rowsPerPage={rowsPerPage}
      onChangePage={handleTableChangePage(setPage)}
      onChangeRowsPerPage={handleTableChangeRowsPerPage(setRowsPerPage, setPage)}
    />
  );
};

// prettier-ignore
export default compose(withTableActions)(UsersTable)
